import React from 'react';
import title from './props';
import style from './style.module.scss';
import classNames from '../../../utils/classNames';

function Title(props: title) {
  const ComponentAs = props.as || 'h3';
  const titleClassNames = `${props.asClassName} ${classNames('title', style, props.classNames)}`;
  return (
      <ComponentAs className={titleClassNames}
        {...(props['data-e2e'] && {'data-e2e': props['data-e2e']})}>
        {props.text}
        {props.children}
      </ComponentAs>
  );
}

export default React.memo(Title);
